import React from 'react'

export function NoiseBackground({ children }: { children: React.ReactNode }) {
	return (
		<div className="relative overflow-hidden bg-gradient-to-br from-slate-800 to-gray-900 dark:from-neutral-900 sm:rounded-2xl">
			{/* Noise Texture */}
			<div
				className="bg-noise absolute inset-0 h-full w-full opacity-10 [mask-image:radial-gradient(#fff,transparent,75%)]"
				style={{
					backgroundImage: 'url(/img/noise.webp)',
					backgroundSize: '30%',
				}}
			></div>
			{/* Gradient Lines (top) */}
			<div className="absolute -top-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-purple-500 to-transparent md:right-60"></div>
			<div className="absolute -top-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-indigo-500 to-transparent md:right-40"></div>
			<div className="absolute -top-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-sky-500 to-transparent md:right-80"></div>
			{/* Gradient Lines (bottom) */}
			<div className="absolute -bottom-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-purple-500 to-transparent md:right-60"></div>
			<div className="absolute -bottom-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-indigo-500 to-transparent md:right-40"></div>
			<div className="absolute -bottom-px right-10 z-10 h-px w-1/2 bg-gradient-to-r from-transparent via-sky-500 to-transparent md:right-80"></div>
			{/* Content */}
			<div className="relative z-20">{children}</div>
		</div>
	)
}
